import React from 'react';
import { Button } from '@/components/ui/button';

import type { OpenCandidatesActionFn, ProgramControlCommonProps, SubmitReportFn } from '../controlTypes';

type MaternalProgramControlsProps = ProgramControlCommonProps & {
  onOpenCandidatesAction: OpenCandidatesActionFn;
  onSubmitReport: SubmitReportFn;
};

export const MaternalProgramControls = ({
  values,
  onFilterChange,
  actionRowClass,
  renderStandardActionButtons,
  renderReportActionLabel,
  onOpenCandidatesAction,
  onSubmitReport,
}: MaternalProgramControlsProps) => (
  <div className="mb-3 flex flex-wrap items-end justify-between gap-4 rounded-[var(--border-radius-medium)] border border-[var(--neutral-gray-40)] bg-white px-4 py-3">
    <div className="flex flex-wrap items-center gap-6">
      <div className="flex items-center gap-3">
        <div className="text-xs font-semibold uppercase tracking-wide text-[var(--neutral-gray-100)]">Currently Ineligible</div>
        <div className="flex items-center gap-4 text-xs text-[var(--neutral-gray-120)]">
          <label className="flex items-center gap-1.5"><input type="radio" name="maternal-currently-ineligible" checked={values.maternalIneligibleFilter === 'y'} onChange={() => onFilterChange('maternalIneligibleFilter', 'y')} />Yes</label>
          <label className="flex items-center gap-1.5"><input type="radio" name="maternal-currently-ineligible" checked={values.maternalIneligibleFilter === 'n'} onChange={() => onFilterChange('maternalIneligibleFilter', 'n')} />No</label>
        </div>
      </div>
    </div>

    <div className={actionRowClass}>
      {renderStandardActionButtons()}
      <Button type="button" variant="outline" size="sm" className="h-8" onClick={() => onOpenCandidatesAction('court-list-report')}>
        {renderReportActionLabel('+ Court List Report')}
      </Button>
      <Button type="button" variant="outline" size="sm" className="h-8" onClick={() => onSubmitReport({ action: 'all-report', download: '1' })}>
        {renderReportActionLabel('Download Candidates List')}
      </Button>
      <Button type="button" variant="outline" size="sm" className="h-8" onClick={() => onSubmitReport({ action: 'all-report', download: '1' })}>
        {renderReportActionLabel('All')}
      </Button>
    </div>
  </div>
);
